import { useRef, useEffect } from 'react';

const FrequencyPopup = ({ isOpen, onClose, selectedFrequency, onFrequencyChange }) => {
  const popupRef = useRef(null);

  const frequencies = [
    { id: 'daily', label: 'Daily' },
    { id: 'weekly', label: 'Weekly' },
    { id: 'monthly', label: 'Monthly' }
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleFrequencySelect = (frequencyId) => {
    onFrequencyChange(frequencyId);
    onClose();
  };

  return (
    <div
      className="export-dropdown-popup"
      ref={popupRef}
      style={{
        minWidth: '150px',
        padding: '8px',
        top: 'calc(100% + 8px)',
        left: '0',
        marginTop: '0'
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        {frequencies.map((freq) => (
          <button
            key={freq.id}
            onClick={() => handleFrequencySelect(freq.id)}
            style={{
              width: '100%',
              textAlign: 'left',
              padding: '8px 12px',
              fontSize: '14px',
              backgroundColor: selectedFrequency === freq.id ? 'rgba(139, 92, 246, 0.2)' : 'transparent',
              border: 'none',
              borderRadius: '6px',
              color: selectedFrequency === freq.id ? '#8B5CF6' : '#fff',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              fontFamily: 'NeoSans, sans-serif'
            }}
            onMouseEnter={(e) => {
              if (selectedFrequency !== freq.id) {
                e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
              }
            }}
            onMouseLeave={(e) => {
              if (selectedFrequency !== freq.id) {
                e.target.style.backgroundColor = 'transparent';
              }
            }}
          >
            {freq.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FrequencyPopup;
